import moment from 'moment'

export const getDefaultMovementDateRange = (referenceDate = moment()) => ({
  startDt: referenceDate.clone().subtract(1, 'month').startOf('day').valueOf(),
  endDt: referenceDate.clone().endOf('day').valueOf()
})
